<template>
  <div class="wrapper">
    <div class="auth-tip-box" v-if="isAuth == false">
      <img src="~@/assets/img/kfc/home_icon_arrow_notice.png" alt="">
      <span class="tip-span">您还未授权公众号，请先</span>
      <span class="to-auth" @click="auth">授权公众号</span>
      <img src="~@/assets/img/kfc/home_icon_arrow_right.png" alt="">
    </div>
    <div class="wechat-wrap">
      <div class="top-part">
        <div class="data-box">
          <div>
            <span class="part-title">可提现金额（元）：</span>
            <span class="part-content">{{ balance }}</span>
          </div>
          <div class="withdraw-box" @click="withdraw()">
            <span class="withdraw-btn">提现</span>
          </div>
        </div>
        <div class="figure-box">
          <img src="~@/assets/img/kfc/home_img_figure.png" alt="">
        </div>
      </div>
      <div class="data-wrap">
        <el-row>
          <el-col :span="6">
            <div class="data-card">
              <div class="card-head background-eef9ff">
                <div>本月新增会员数</div>
                <div>{{ statisticsInfo.userCountMonth }}</div>
              </div>
              <div class="card-content">
                <div><span class="card-num today-member">{{ statisticsInfo.userCountToday }}</span>个</div>
                <div class="content-desc">
                  <span>今日新增会员</span>
                  <span :class="[increaseUser >= 0 ? 'up_active' : '', 'float-num']">{{ increaseUser >= 0 ? '较昨日上升' :
                    '较昨日下降' }}<span>{{ Math.abs(increaseUser) }}</span>个</span>
                  <img src="~@/assets/img/kfc/home_icon_arrow_up.png" v-if="increaseUser >= 0" />
                  <img src="~@/assets/img/kfc/home_icon_arrow_below.png" v-else />
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="data-card margin-left-16">
              <div class="card-head background-fff5ed">
                <div>本月新增订单数</div>
                <div>{{ statisticsInfo.orderCountMonth }}</div>
              </div>
              <div class="card-content">
                <div><span class="card-num today-member">{{ statisticsInfo.orderCountToday }}</span>件</div>
                <div class="content-desc">
                  <span>今日新增订单</span>
                  <span :class="[increaseOrder >= 0 ? 'up_active' : '', 'float-num']">{{ increaseOrder >= 0 ? '较昨日上升' :
                    '较昨日下降' }}<span>{{ Math.abs(increaseOrder) }}</span></span>
                  <img src="~@/assets/img/kfc/home_icon_arrow_up.png" v-if="increaseOrder >= 0" />
                  <img src="~@/assets/img/kfc/home_icon_arrow_below.png" v-else />
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="data-card margin-left-16">
              <div class="card-head background-ebfbf9">
                <div>本月结算收入</div>
                <div>{{ statisticsInfo.commissionMonth }}</div>
              </div>
              <div class="card-content">
                <div><span class="card-num today-member">{{ statisticsInfo.commissionToday }}</span>元</div>
                <div class="content-desc">
                  <span>今日预估佣金</span>
                  <span :class="[increaseCommission >= 0 ? 'up_active' : '', 'float-num']">{{ increaseCommission >= 0 ?
                    '较昨日上升' : '较昨日下降' }}<span>{{ Math.abs(increaseCommission).toFixed(2) }}</span></span>
                  <img src="~@/assets/img/kfc/home_icon_arrow_up.png" v-if="increaseCommission >= 0" />
                  <img src="~@/assets/img/kfc/home_icon_arrow_below.png" v-else />
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="data-card margin-left-16">
              <div class="card-head background-f5f3fe">
                <div>本月推广利润</div>
                <div>{{ statisticsInfo.profitMonth }}</div>
              </div>
              <div class="card-content">
                <div><span class="card-num today-member">{{ statisticsInfo.profitToday }}</span>元</div>
                <div class="content-desc">
                  <span>今日利润</span>
                  <span :class="[increaseProfit >= 0 ? 'up_active' : '', 'float-num']">{{ increaseProfit >= 0 ? '较昨日上升' :
                    '较昨日下降' }}<span>{{ Math.abs(increaseProfit).toFixed(2) }}</span></span>
                  <img src="~@/assets/img/kfc/home_icon_arrow_up.png" v-if="increaseProfit >= 0" />
                  <img src="~@/assets/img/kfc/home_icon_arrow_below.png" v-else />
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="data-trend">
        <div class="tilte-text">近15日订单数据</div>
        <div class="echart-content">
          <div class="echart-dom" style="max-width: 930px" id="chart-line-box">
          </div>
        </div>
      </div>
    </div>
    <withdraw ref="withdraw" @close="refreshBalance"></withdraw>
    <realname ref="realname"></realname>
  </div>
</template>

<script>
import { getUserUUID, getPlatformUuidKfc, getIsAuthKfc, getPlatformNameKfc, getHeadImgKfc, setUserUUID, setPlatformUuidKfc, setPlatformNameKfc, setHeadImgKfc, setIsAuthKfc } from '@/utils/auth'
import echarts from 'echarts'
import Withdraw from '@/components/kfc/Withdraw.vue'
import Realname from '@/components/kfc/Realname.vue'
import home from '@/javaApi/kfc/home'
const homeModel = new home()
import kfc from '@/javaApi/kfc/kfc'
const kfcModel = new kfc()
import withdraw from '@/javaApi/kfc/withdraw'
const withdrawModel = new withdraw()
import official from '@/javaApi/official'
const officialModel = new official()

export default {
  name: "Wechat",
  components: {
    Withdraw,
    Realname,
  },
  data: function () {
    return {
      platformUuid: getPlatformUuidKfc() || '',
      isAuth: getIsAuthKfc() === 'true' ? true : false,
      platformNameKfc: getPlatformNameKfc(),
      headImgKfc: getHeadImgKfc(),
      balance: '0.00',
      chartLine: undefined,
      listLoading: false,
      //isRealName: false,
      activeIndex: 0,
      statisticsInfo: {
        commissionMonth: '0.00',
        commissionToday: '0.00',
        commissionYesterday: '0.00',
        orderCountMonth: '0',
        orderCountToday: '0',
        orderCountYesterday: '0',
        profitMonth: '0.00',
        profitToday: '0.00',
        profitYesterday: '0.00',
        userCountMonth: '0',
        userCountToday: '0',
        userCountYesterday: '0'
      },
      report: {
        dayList: [],
        orderNumList: [],
      }
    }
  },
  computed: {
    increaseUser() {
      let increaseUser = this.statisticsInfo.userCountToday - this.statisticsInfo.userCountYesterday
      return parseInt(increaseUser)
    },
    increaseOrder() {
      let increaseOrder = this.statisticsInfo.orderCountToday - this.statisticsInfo.orderCountYesterday
      return parseInt(increaseOrder)
    },
    increaseCommission() {
      let commission = this.statisticsInfo.commissionToday - this.statisticsInfo.commissionYesterday
      return parseFloat(commission) ? parseFloat(commission) : 0
    },
    increaseProfit() {
      let profit = this.statisticsInfo.profitToday - this.statisticsInfo.profitYesterday
      return parseFloat(profit) ? parseFloat(profit) : 0
    }
  },
  mounted: function () {
    let condition = this.platformUuid == '' || this.platformUuid == 0
    if (!condition) {
      this.$store.dispatch('kfc/changePlatformNameKfc', this.platformNameKfc)
      this.$store.dispatch('kfc/changeHeadImgKfc', this.headImgKfc)
      this.initData()
      this.getWithdrawInfo()
    } else {
      this.getHasAuthPubilc()
    }
  },
  methods: {
    initData() {
      this.listLoading = true
      let param = {
        platformUuid: this.platformUuid
      }
      homeModel.getStatisticsData(param).then((response) => {
        this.listLoading = false
        console.log(1111, response)
        var res = response.data
        if (res.success) {
          if (typeof res.data.platformStat === 'object' && res.data.platformStat !== null) {
            this.statisticsInfo = res.data.platformStat;
          }
          this.report = res.data.stringListMap;
          this.initEchart();
        } else {
          let messgae = res.message ? res.message : '系统异常请稍后再试'
          this.$Message.error(messgae)
        }
      }).catch(error => {
        this.listLoading = false
        if (error != 'token invalid') {
          this.$Message.error('系统异常请稍后再试！')
        }
      })
    },
    //获取公众号信息
    getHasAuthPubilc() {
      this.listLoading = true
      officialModel.getAuthPublicList({ openUserUuid: getUserUUID() }).then((response) => {
        this.listLoading = false
        var res = response.data
        if (res.success) {
          if (res.data && res.data.binds && res.data.binds.length > 0) {
            // 取第一条公众号数据，做为默认公众号
            var defaultKfc = res.data.binds[0];
            setPlatformUuidKfc(defaultKfc.platformUuid) // 公众号UUID
            setPlatformNameKfc(defaultKfc.platformName) // 公众号名称
            setHeadImgKfc(defaultKfc.headImg) // 公众号logo
            // 公众号是否已授权
            if (defaultKfc.platformUuid !== '' && defaultKfc.platformName !== '') {
              this.isAuth = true
              setIsAuthKfc(true)
            } else {
              this.isAuth = false
              setIsAuthKfc(false)
            }
            this.$store.dispatch('kfc/changePlatformNameKfc', defaultKfc.platformName)
            this.$store.dispatch('kfc/changeHeadImgKfc', defaultKfc.headImg)
            this.platformUuid = defaultKfc.platformUuid
            if (this.platformUuid) {
              this.initData()
              this.getWithdrawInfo()
            }
          } else {
            setPlatformUuidKfc(0);
            setPlatformNameKfc('')
            setHeadImgKfc('')
            setIsAuthKfc(false)
            this.isAuth = false
            this.$store.dispatch('kfc/changePlatformNameKfc', '')
            this.$store.dispatch('kfc/changeHeadImgKfc', '')
          }
        } else {
          setPlatformUuidKfc(0);
          setPlatformNameKfc('')
          setHeadImgKfc('')
          setIsAuthKfc(false)
          this.isAuth = false
          this.$store.dispatch('kfc/changePlatformNameKfc', '')
          this.$store.dispatch('kfc/changeHeadImgKfc', '')
          this.$Message.error(res.message)
          return
        }
      }).catch(error => {
        console.log(error)
        if (error != 'token invalid') {
          this.$Message.error('系统异常请稍后再试！')
        }
      })
    },
    // 获取提现数据
    getWithdrawInfo() {
      withdrawModel.getWithdrawInfo({ platformUuid: this.platformUuid }).then((response) => {
        var res = response.data
        if (res.success && res.data) {
          this.balance = parseFloat(res.data.balance).toFixed(2)
        }
      }).catch(error => {
        console.log(error)
        if (error != 'token invalid') {
          this.$Message.error('系统异常请稍后再试！')
        }
      })
    },
    // 绘制图表
    initEchart: function () {
      if (!this.report) {
        this.report.dayList = []
        this.report.orderNumList = []
      }
      if (!this.report.dayList) {
        this.report.dayList = []
      }
      if (!this.report.orderNumList) {
        this.report.orderNumList = []
      }

      if (this.report.dayList.length == 0) {
        this.report.dayList = ['暂无数据']
      }

      if (this.report.orderNumList.length == 0) {
        this.report.orderNumList = [0];
      }
      let chartLineBox = document.getElementById('chart-line-box')
      if (!chartLineBox) {
        return
      }
      this.chartLine = echarts.init(document.getElementById('chart-line-box'))
      // 指定图表的配置项和数据
      var option = {
        tooltip: {              //设置tip提示
          trigger: 'axis'
        },
        legend: {               //设置区分（哪条线属于什么）
          data: ['预估订单量']
        },
        color: ['#D63036'],     //设置区分（每条线是什么颜色，和 legend 一一对应）
        xAxis: {                //设置x轴
          type: 'category',
          boundaryGap: false,   //坐标轴两边不留白
          data: this.report.dayList,
          //data: ['2020-12-16', '2020-12-17', '2020-12-18', '2020-12-19', '2020-12-20', '2020-12-21', '2020-12-22', '2020-12-23', '2020-12-24', '2020-12-25', '2020-12-26', '2020-12-27', '2020-12-28', '2020-12-29', '2020-12-30', '2020-12-31'],
          name: '',             //X轴 name
          nameTextStyle: {      //坐标轴名称的文字样式
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 0, 20]
          },
          axisLine: {           //坐标轴轴线相关设置。
            lineStyle: {
              color: '#FA6F53',
            }
          }
        },
        yAxis: {
          name: '',
          nameTextStyle: {
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 10, 0]
          },
          axisLine: {
            lineStyle: {
              color: '#FA6F53',
            }
          },
          type: 'value'
        },
        series: [
          {
            name: '订单量',
            //data: [220, 232, 201, 234, 290, 230, 220, 100, 180, 150, 200, 280, 300, 290, 280],
            data: this.report.orderNumList,
            type: 'line',               // 类型为折线图
            lineStyle: {                // 线条样式 => 必须使用normal属性
              normal: {
                color: '#3D9EFC',
              }
            },
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option);
    },
    //提现
    withdraw: function () {
      //if(this.isRealName){//已实名
      let settleBalance = this.balance
      if (settleBalance <= 0) {
        this.$Message.error('暂无可提现金额')
        return
      }
      this.$refs.withdraw.init()
      //}else{//未实名认证
      //this.$refs.realname.init()
      //}
    },
    //授权
    auth: function () {
      this.$store.dispatch('nav/changeKfcAccountActiveIndex', 4)
      this.$router.push({
        path: '/pc/kfc/authorization',
      });
    },
    // 是否过期的判断
    getTimeTip() {
      let now = this.$moment()
      let effectTime = this.$moment(this.basicInfo.effectTime)
      let timeDiff = effectTime.diff(now)
      if (timeDiff >= 0) {
        return ''
      }
      return '(已过期)'
    },
    // 刷新账户余额
    refreshBalance(val) {
      this.balance = val
    }
  }
}
</script>

<style scoped>
.margin-left-16 {
  margin-left: 16px;
}

.main-content {
  padding: 0 30px 20px 30px !important;
  min-width: 765px !important;
}

.wrapper {
  width: 100%;
  font-size: 12px;
}

.wrapper .tilte-text {
  font-size: 20px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper .auth-tip-box {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  color: #666666;
  text-align: justify;
  line-height: 40px;
  background: #FFFBE6;
  border-radius: 4px;
  height: 40px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.wrapper .auth-tip-box img {
  width: 20px;
}

.wrapper .auth-tip-box .tip-span {
  padding: 0 5px;
}

.wrapper .auth-tip-box .to-auth {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 16px;
  color: #D63036;
  ;
  cursor: pointer;
  text-decoration: underline;
}

.wrapper .wechat-wrap {
  margin-top: 50px;
}

.wrapper .wechat-wrap .top-part {
  padding: 29px 20px;
  background: #1287EA;
  border: 1px solid #EEEEEE;
  color: #FFFFFF;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
}

.data-box {
  display: flex;
  align-items: center;
}

.wrapper .wechat-wrap .top-part .part-title {
  opacity: 0.6;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  color: #FFFFFF;
}

.wrapper .wechat-wrap .top-part .part-content {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 24px;
  color: #FFFFFF;
}

.wrapper .wechat-wrap .top-part .withdraw-box {
  margin-left: 40px;
  background: #FFFFFF;
  border-radius: 2px;
  font-family: Alibaba-PuHuiTi-M;
  font-size: 16px;
  color: #1287EA;
  text-align: center;
  width: 100px;
  height: 42px;
  line-height: 42px;
  cursor: pointer;
}

.wrapper .wechat-wrap .top-part .figure-box {
  margin-top: -91px;
}

.wrapper .wechat-wrap .top-part .figure-box img {
  width: 114px;
}

.wrapper .data-wrap {
  margin-top: 20px;
  color: #666666;
}

.wrapper .data-wrap .data-card {
  background: #FFFFFF;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  font-size: 16px;
}

.wrapper .data-wrap .data-card .background-eef9ff {
  background: #F1FCFE;
}

.wrapper .data-wrap .data-card .background-fff5ed {
  background: #FFF6F1;
}

.wrapper .data-wrap .data-card .background-ebfbf9 {
  background: #F2FEF2;
}

.wrapper .data-wrap .data-card .background-f5f3fe {
  background: #F9F8FE;
}

.wrapper .data-wrap .data-card .card-head {
  border-radius: 4px 4px 0 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
  padding: 13px 16px;
}

.wrapper .data-wrap .data-card .card-content {
  padding: 10px 10px;
}

.wrapper .data-wrap .data-card .card-content .card-num {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 28px;
  color: #222222;
  line-height: 38px;
}

.wrapper .data-wrap .data-card .card-content .float-num {
  font-family: Alibaba-PuHuiTi-R;
  color: #D63036;
}

.wrapper .data-wrap .data-card .card-content .float-num.up_active {
  color: #30B583;
}

.wrapper .data-wrap .data-card .card-content .content-desc {
  font-size: 14px;
}

.wrapper .data-wrap .data-card .card-content .content-desc img {
  width: 20px;
}

.wrapper .data-trend {
  margin-top: 30px;
}

.wrapper .echart-content {
  border: 1px solid #eeeeee;
  border-radius: 4px;
  width: 100%;
  margin-top: 0.24rem;
}

.wrapper .echart-dom {
  height: 300px;
  padding: 20px;
}

.wrapper .echart-content .echar-desc {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.wrapper .echart-content .echar-desc .detail-item {
  margin-right: 34px;
}

.wrapper .echart-content .echar-desc .detail-item .detail-badge {
  border-radius: 100%;
  -webkit-box-shadow: 0 0 0 1px #fff;
  box-shadow: 0 0 0 1px #fff;
  width: 8px;
  height: 8px;
  display: inline-block;
  position: relative;
  top: -1px;
  margin-right: 10px;
}

.wrapper .echart-content .echar-desc .detail-item .detail-title {
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  padding-right: 10px;
}

.wrapper .echart-content .echar-desc .detail-item .detail-content {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}

.wrapper .echart-content .echart-info {
  padding: 20px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kfc/statistics/Index.vue